<div class="employees-page employee-import-page">
  <main class="employees-shell">
    <section class="employees-hero">
      <div class="hero-copy">
        <button class="back-btn" type="button" routerLink="/employees">
          ← Back to Employees
        </button>

        <div class="eyebrow">Employee Management</div>
        <h1>Import Employees</h1>
        <p>Upload a completed employee template to validate and import employee records.</p>
      </div>
    </section>

    <section class="import-layout">
      <div class="employees-card import-card">
        <div class="employees-card-header">
          <div>
            <h2>Upload File</h2>
            <p>Select an Excel or CSV file to begin validation.</p>
          </div>
        </div>

        <div
          class="dropzone"
          [class.active]="selectedFile"
          (dragover)="$event.preventDefault()"
          (drop)="handleDrop($event)"
        >
          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            hidden
            #fileInput
            id="fileInput"
            (change)="onFileSelected($event)"
          />

          <div *ngIf="!selectedFile" class="dropzone-content">
            <div class="upload-icon">↑</div>
            <h3>Drag & drop file here</h3>
            <p>or browse to upload .xlsx, .xls, or .csv</p>
            <button type="button" class="action-btn primary" (click)="fileInput.click()">Browse File</button>
          </div>

          <div *ngIf="selectedFile" class="dropzone-content">
            <div class="upload-icon success">✓</div>
            <h3>{{ selectedFile.name }}</h3>
            <p>File ready for validation and import.</p>

            <div class="dropzone-actions">
              <button type="button" class="action-btn secondary" (click)="fileInput.click()">Change File</button>
              <button type="button" class="danger-btn" (click)="removeFile()">Remove</button>
            </div>
          </div>
        </div>

        <button class="upload-btn" [disabled]="!selectedFile || isLoading" (click)="upload()">
          <ng-container *ngIf="!isLoading">Upload & Validate</ng-container>
          <ng-container *ngIf="isLoading">
            <div class="spinner"></div>
            Validating...
          </ng-container>
        </button>

        <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
      </div>

      <div class="employees-card log-card" *ngIf="logs.length">
        <div class="employees-card-header">
          <div>
            <h2>Upload Logs</h2>
            <p>Review recent upload results and validation details.</p>
          </div>
        </div>

        <div class="log-list">
          <button class="log-entry" type="button" *ngFor="let log of logs" (click)="activeLog = log">
            <div
              class="status-icon"
              [ngClass]="{
                success: log.successCount === log.totalRows,
                partial: log.successCount > 0 && log.successCount < log.totalRows,
                fail: log.successCount === 0
              }"
            >
              <span *ngIf="log.successCount === log.totalRows">✓</span>
              <span *ngIf="log.successCount > 0 && log.successCount < log.totalRows">!</span>
              <span *ngIf="log.successCount === 0">×</span>
            </div>

            <div class="summary-info">
              <div class="timestamp">{{ log.timestamp | date:'short' }}</div>
              <div class="summary-stats">
                Total <strong>{{ log.totalRows }}</strong>
                <span>•</span>
                Uploaded <strong>{{ log.successCount }}</strong>
                <span>•</span>
                Duration <strong>{{ log.durationMs }}ms</strong>
              </div>
            </div>

            <span class="row-action">View →</span>
          </button>
        </div>
      </div>
    </section>
  </main>

  <div class="log-modal" *ngIf="activeLog">
    <div class="modal-backdrop" (click)="activeLog = null"></div>

    <div class="modal-content">
      <button class="close-btn" type="button" (click)="activeLog = null">&times;</button>

      <div class="modal-header">
        <h3>Upload Details</h3>
        <p class="timestamp">{{ activeLog.timestamp | date:'short' }}</p>
      </div>

      <div class="modal-meta">
        <div><strong>Uploaded By:</strong> {{ activeLog.uploadedBy }}</div>
        <div><strong>Total Rows:</strong> {{ activeLog.totalRows }}</div>
        <div><strong>Successful:</strong> {{ activeLog.successCount }}</div>
        <div><strong>Failed:</strong> {{ activeLog.totalRows - activeLog.successCount }}</div>
      </div>

      <div class="modal-body" *ngIf="failedRows.length">
        <h4>Validation Errors</h4>

        <div class="invalid-fields">
          <div class="field" *ngFor="let e of aggregatedErrors">
            <strong>{{ e.field }}</strong>:
            <span class="value" *ngFor="let v of e.values; let last = last">
              "{{ v }}"<span *ngIf="!last">, </span>
            </span>
          </div>
        </div>

        <h4>Employees Not Imported</h4>

        <div
          class="failed-row"
          *ngFor="let r of failedRows"
          [ngClass]="{ 'partial-row': r.status === 'partial', 'fail-row': r.status === 'fail' }"
        >
          <div class="row-header">
            <span class="employee-number">Employee #{{ r.employeeNumber }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>